import React from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as RaceActions from "../../../../actions/race"
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from '../../../reusable/UserFieldElement';
import config from "../../../../../../server/src/config";
import moment from "moment";

const installer = typeof(window) === "undefined"
    ? null // <- don't require the installer on the server (it will crash - no webpack).
    : require("!!file-loader?name=[name].[ext]!../../../../../res/files/BrevCommUtil.exe");

class ImportDevicesDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            deviceType: 'unikon',
            commPort: 'com1',
            week: moment(new Date()).add(-3, 'days').isoWeek().toString(),
            reset: true,
            overwrite: true,
            installerSrc: null
        }
    }

    componentDidMount() {
        this.setState({
            installerSrc: installer
        });
    }

    componentWillUnmount() {
        this.props.race.deviceImports.forEach((outstanding, id) => {
            this.props.dispatch(RaceActions.updateDeviceImport(id, {
                info: "cancelled",
            }));
        });
    }

    fields = [];
    render() {
        const isBusy = this.props.race.deviceImports.some((data) => {
            const typ = data.get('requestType');
            return typ === 'signups' || typ === 'results';
        });
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {
                    this.props.onClose()
                }}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content: {
                        height: '450px',
                        width: '650px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title" onClick={() => {
                        return;
                        // TODO: Remove this.
                        console.log("Outstandings: ", this.props.race.deviceImports.count(), this.props.race.deviceImports.toJS());
                        if (this.props.race.deviceImports.count() > 0) {
                            const outstanding = this.props.race.deviceImports.keySeq().first();
                            console.log("Outstanding send: ", this.props.race.deviceImports.get(outstanding).toJS());
                            let data = '1';
                            if (this.props.race.deviceImports.get(outstanding).toJS().deviceType === 'tauris') data = `
2   001 24072015002907152000152005
3   001  22 209  0640 93 2707161530
3   001  22 209  0641 93 2707153334
3   001  22 209  0642 93 2707161535
                            `;
                            else if (this.props.race.deviceImports.get(outstanding).toJS().deviceType === 'unikon') data = `
    209001        230725143000290725151617      15161794 26/07
 19  2090210            1545312707
 19  2090214            1705122707
 19  2090230
`;
                            this.props.dispatch(RaceActions.updateDeviceImport(outstanding, {
                                data: data,
                                info: "success",
                            }));
                        }
                    }}>Indlæs fra elektronisk udstyr</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <table className="fields">
                                <tbody>
                                    <tr>
                                        <td className="large-vertical-spacing" style={{width:"50%"}}>
                                            <div className="small-vertical-spacing">System</div>
                                            <div className="small-vertical-spacing">
                                                <input type="radio" id="deviveTypeUnikon" name="deviveType" checked={this.state.deviceType === 'unikon'} onClick={() => this.setState({deviceType: 'unikon'})}/> <label htmlFor="deviveTypeUnikon">Unikon</label>
                                            </div>
                                            {/*<div className="small-vertical-spacing">
                                                <input type="radio" id="deviveTypeTipes" name="deviveType" checked={this.state.deviceType === 'tipes'} onClick={() => this.setState({deviceType: 'tipes'})}/> <label htmlFor="deviveTypeTipes">Tipes</label>
                                            </div>*/}
                                            <div className="small-vertical-spacing">
                                                <input type="radio" id="deviveTypeTauris" name="deviveType" checked={this.state.deviceType === 'tauris'} onClick={() => this.setState({deviceType: 'tauris'})}/> <label htmlFor="deviveTypeTauris">Tauris</label>
                                            </div>
                                        </td>
                                        <td className="large-vertical-spacing" style={{width:"50%"}}>
                                            <div className="small-vertical-spacing">Kommunikationsport</div>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div className="small-vertical-spacing">
                                                                <input type="radio" id="commPort1" name="commPort" checked={this.state.commPort === 'com1'} onClick={() => this.setState({commPort: 'com1'})}/> <label htmlFor="commPort1">COM1{this.props.race.deviceComPorts.includes(':com1:') ? '*' : ''}</label>
                                                            </div>
                                                            <div className="small-vertical-spacing">
                                                                <input type="radio" id="commPort2" name="commPort" checked={this.state.commPort === 'com2'} onClick={() => this.setState({commPort: 'com2'})}/> <label htmlFor="commPort2">COM2{this.props.race.deviceComPorts.includes(':com2:') ? '*' : ''}</label>
                                                            </div>
                                                            <div className="small-vertical-spacing">
                                                                <input type="radio" id="commPort3" name="commPort" checked={this.state.commPort === 'com3'} onClick={() => this.setState({commPort: 'com3'})}/> <label htmlFor="commPort3">COM3{this.props.race.deviceComPorts.includes(':com3:') ? '*' : ''}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="small-vertical-spacing">
                                                                <input type="radio" id="commPort4" name="commPort" checked={this.state.commPort === 'com4'} onClick={() => this.setState({commPort: 'com4'})}/> <label htmlFor="commPort4">COM4{this.props.race.deviceComPorts.includes(':com4:') ? '*' : ''}</label>
                                                            </div>
                                                            <div className="small-vertical-spacing">
                                                                <input type="radio" id="commPort5" name="commPort" checked={this.state.commPort === 'com5'} onClick={() => this.setState({commPort: 'com5'})}/> <label htmlFor="commPort5">COM5{this.props.race.deviceComPorts.includes(':com5:') ? '*' : ''}</label>
                                                            </div>
                                                            <div className="small-vertical-spacing">
                                                                <input type="radio" id="commPort6" name="commPort" checked={this.state.commPort === 'com6'} onClick={() => this.setState({commPort: 'com6'})}/> <label htmlFor="commPort6">COM6{this.props.race.deviceComPorts.includes(':com6:') ? '*' : ''}</label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label htmlFor="week">Uge</label></td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                              name="week" id="week" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}"}]} value={this.state.week}
                                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              ref={instance => { this.fields[0] = instance; }}
                                            />
                                        </td>
                                    </tr>
                                    {/*<tr>
                                        <td>
                                            <label htmlFor="reset">Slet ikke fundne duer ved anmeldelse</label>
                                        </td>
                                        <td>
                                            <input type="checkbox" name="reset" id="reset" checked={this.state.reset} onChange={this.onCheckFieldChange}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label htmlFor="overwrite">Flyt duer hvis anmeldt på andre flyvninger</label>
                                        </td>
                                        <td>
                                            <input type="checkbox" name="overwrite" id="overwrite" checked={this.state.overwrite} onChange={this.onCheckFieldChange}/>
                                        </td>
                                    </tr>*/}
                                </tbody>
                            </table>
                            {this.props.race.deviceImporterVersion !== null && this.props.race.deviceImporterVersion !== config.commUtility.version ? <div className = "downloadCommInstaller">
                                <div>{this.props.race.deviceImporterVersion === "-" ? "Programmet til kommunikation med anlæggene er ikke installeret" : "Der er kommet ny version af kommunikationsprogrammet for anlæggene"}</div>
                                <div>Klik <a href = {this.state.installerSrc}>her</a> for at downloade kommunikationsprogrammet</div>
                            </div> : <div className="downloadCommInstaller">
                                <div>Klik <a href={this.state.installerSrc}>her</a> for at downloade kommunikationsprogrammet</div>
                            </div>}
                        </div>
                    </div>

                    <div className="actions-row">
                        {isBusy ? null : <button className="btn-primary" name="signups" disabled={this.props.race.deviceImporterVersion === null || this.props.race.deviceImporterVersion === "-"} onClick={() => {this.onImport('signups')}}>Indlæs anmeldelser</button>}
                        {isBusy ? null : <button className="btn-primary" name="results" disabled={this.props.race.deviceImporterVersion === null || this.props.race.deviceImporterVersion === "-"} onClick={() => {this.onImport('results')}}>Indlæs resultater</button>}
                        {isBusy ? <button className="btn-primary" name="results" onClick={() => {this.onCancelImport('results')}}>Afbryd indlæsning</button> : null}
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onImport = (type) => {
        if (this.allInputValid()) {
            var id = (moment().valueOf() + '-' + this.props.auth.id).slice(0, 25);
            let cb = window.location.origin;
            if (cb.slice(-1) !== '/') cb += '/';
            cb += 'api/device-import/' + id;
            this.props.dispatch(RaceActions.startDeviceImport(id, {
                requestType: type,
                deviceType: this.state.deviceType,
                commPort: this.state.commPort,
                week: parseInt(this.state.week),
                reset: this.state.reset,
                overwrite: this.state.overwrite,
                club: this.props.auth.currentEntity,
            }, () => {
                window.location.href = config.commUtility.url + "?callback=" + encodeURIComponent(cb) + "&command=read-data&id=" + encodeURIComponent(id) + "&device=" + this.state.deviceType + "&port=" + this.state.commPort;
            }));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    onCancelImport = () => {
        this.props.race.deviceImports.filter(data => {
            const typ = data.get('requestType');
            return typ === 'signups' || typ === 'results'
        }).forEach((data, id) => {
            this.props.dispatch(RaceActions.updateDeviceImport(id, {
                info: "cancelled",
            }));
        });
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onCheckFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.checked});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };
}

const mapStateToProps = (state) => ({
    auth: {
        id: state.auth.id,
        currentEntity: state.auth.currentEntity,
    },
    race: {
        deviceImporterVersion: state.race.deviceImporterVersion,
        deviceImports: state.race.deviceImports,
        deviceComPorts: state.race.deviceComPorts,
    }
});

export default connect(mapStateToProps)(ImportDevicesDialog);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/ImportDevicesDialog.js